module.exports = __webpack_public_path__ + "static/media/W_T.c3d03205.png";